function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDistributedMosquitoPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-0-0",
    width: 19.84375,
    height: 19.84375,
    x: -1.7763568e-15,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d12b2d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-5-7",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.04681459px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 5.5328044,280.1989 c -0.5037799,0.0111 -0.87004,0.47813 -0.85094,0.9762 0.003,0.60585 0.57829,1.40808 1.34047,2.20603 -0.9854899,-0.54698 -1.8175601,-0.9617 -2.0677501,-0.95427 -0.73759,0.0219 -0.76307,1.12846 -0.4809799,1.67809 0.44358,1.04243 4.2821202,1.97389 5.7309302,2.29148 -0.2191301,0.1631 -0.4174401,0.34572 -0.5607,0.48616 -0.6353101,-0.0284 -1.54656,0.006 -2.4141801,0.31106 -1.5518501,0.54489 -2.3982702,1.88442 -2.3277302,2.72445 0.0705,0.84004 0.047,1.13512 0.7759301,1.0443 0.66583,-0.083 1.9993801,-0.37537 4.4832303,-2.36336 0.020399,0.0124 0.0406,0.0248 0.0611,0.0371 -0.1208801,0.10293 -1.9383002,1.65272 -2.05203,1.87234 -0.11757,0.22704 -0.82296,1.24863 -1.5283501,1.7027 -0.7053702,0.45408 -0.8699902,0.63574 -1.7634601,0.90819 -0.8935001,0.27244 -0.14111,0.49948 0.2821199,0.36325 0.4232201,-0.13622 1.4107901,-0.40868 2.3748101,-1.40764 0.9640301,-0.99897 0.9875401,-1.27135 0.9875401,-1.27135 l 2.0808702,-1.95724 c 0.0805,0.0404 0.1609998,0.0781 0.2410899,0.11253 l -0.7466401,1.84468 c 0,0 -0.0469,1.24864 -0.6347799,1.86164 -0.58782,0.613 -1.1381502,0.74922 -1.4908401,0.88545 -0.51064,0.11216 -0.69635,0.4995 -0.0615,0.38598 0.63485,-0.11352 1.83451,-0.56757 2.23422,-1.45302 0.3997101,-0.88543 0.49373,-1.29417 0.42319,-1.58931 -0.0497,-0.20812 0.4690794,-1.19756 0.7818894,-1.76821 0.0199,0.004 0.0398,0.009 0.0594,0.0123 0.33142,0.0576 0.60357,0.0165 0.82517,-0.0884 l 1.17866,1.277 0.77585,2.54278 c 0,0 0.80951,0.43666 1.39732,0.50477 0.587821,0.0681 0.882801,0.0816 1.132611,0.0736 0.45412,-0.0144 -0.0653,-0.43525 -0.27692,-0.38985 -0.211621,0.0454 -1.66515,-0.18859 -1.829731,-0.48374 -0.16459,-0.29514 -0.68187,-2.27029 -0.75241,-2.42921 -0.0476,-0.10711 -0.78091,-0.86412 -1.26648,-1.35967 0.22303,-0.2378 0.3588,-0.55704 0.42867,-0.86739 0.0102,-0.0475 0.0189,-0.0935 0.0256,-0.13845 0.0958,0.0619 0.19607,0.11253 0.29794,0.14861 0.16035,0.0568 0.32648,0.0575 0.47903,0.015 l 2.521651,3.16911 1.18973,1.05194 -3.261961,-4.52706 c 0.0972,-0.1291 0.156331,-0.28742 0.156331,-0.4612 0,-0.12425 -0.0279,-0.24845 -0.0768,-0.36828 0.17441,-0.0565 0.362011,-0.12091 0.51391,-0.18204 0.39965,-0.16079 1.204371,-0.51845 1.438101,-0.96325 0.23372,-0.4448 0.532879,-1.32517 0.3492,-1.55715 -0.18367,-0.23199 -0.19529,0.88685 -0.831301,1.51707 -0.53007,0.52526 -1.454989,0.70813 -1.75147,0.75518 -0.19273,-0.20825 -0.441149,-0.37305 -0.69118,-0.45329 -0.453299,-0.14547 -0.82228,0.0252 -0.97432,0.35203 -0.286359,-0.27451 -0.54229,-0.28293 -0.8629,-0.30474 -0.8131513,-1.13544 -4.0514913,-5.466 -4.6435915,-5.70257 -0.1278599,-0.0511 -0.2514799,-0.0726 -0.3677399,-0.0701 z m 0.12177,0.47898 c 0.17267,0.004 0.3180702,0.12227 0.5154901,0.27279 0.3159,0.2408 4.0069195,5.02491 4.0069195,5.02491 0,0 -0.6317693,-0.0321 -0.6899694,0.0401 -0.0581,0.0723 -3.1755602,-2.71306 -3.7242201,-3.44352 -0.5486601,-0.73045 -0.8397401,-1.49405 -0.4655301,-1.75796 0.14034,-0.099 0.25371,-0.13839 0.35731,-0.1363 z m -1.4837699,2.31825 c 0.1804599,-10e-4 0.4178099,0.10269 0.6359099,0.16128 0.16422,0.0442 1.1578201,0.55995 2.24296,1.13595 l 2.1339001,1.89462 c -0.5987799,-0.17314 -3.59057,-1.04779 -4.31154,-1.47135 -0.7983501,-0.46903 -1.0647601,-1.00044 -0.98317,-1.45571 0.0357,-0.19918 0.1415899,-0.26379 0.28194,-0.26479 z",
    id: "path11772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistributedMosquitoPoint);
export default __webpack_public_path__ + "static/media/icon-distributed-mosquito-point.bbb203f22fb4d1e84b0cc8a825e5cf96.svg";
export { ForwardRef as ReactComponent };